// extracted by mini-css-extract-plugin
module.exports = {"__is__min":"App___is__min_F0xK-","__drag__container":"App___drag__container_1FWPV"};